import { Polygon } from '@/_models/virtualStaging/Polygon';
import { ProductStatus } from '@/_models/eCommerce/Product';

export const preparePolygonResponse = (polygons: any[], products: any[]) =>
  (polygons || [])
    .map((item: Polygon) => new Polygon(item))
    .filter(({ product }: any) => !product || (product && products.some((item) => item.id === product?.id && item.status === ProductStatus.ACTIVE)));
